import { ValidationError } from '../../shared/errors/BaseErrors';

export class AdvertTitle {
  private readonly value: string;
  private constructor(value: string) { this.value = value; }
  public static create(raw: string): AdvertTitle {
    const trimmed = (raw ?? '').trim();
    if (trimmed.length === 0) throw new ValidationError('Advert title cannot be empty');
    if (trimmed.length > 255) throw new ValidationError('Advert title too long');
    return new AdvertTitle(trimmed);
  }
  public get Value(): string { return this.value; }
}
